import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//pages
import { PedidoPage } from '../pedido/pedido';
import { JanelaPage } from '../janela/janela';

//PROVIDERS
import { Services, Tools, User } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-lista',
  templateUrl: 'lista.html',
})
export class ListaPage {
  pedidos:any = [];
  janelas:any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private services: Services,
    private tools: Tools,
    private user: User
  ) {
  }

  ionViewDidLoad(){
    let motId = this.user.getUser()._id+'';
    console.log(motId)
    let query = {ativo:true,motoristaId:motId,status:{$in:['gray','primary']}}
    this.services.getData('cadRotas',query,(result)=>{
      console.log(result)

    });
  }

  openPedido(janela:any){
    let pedidos = this.pedidos.filter(e=>e.pedido.initEntrega+'' == janela.initEntrega+'');
    this.navCtrl.push(JanelaPage,{item:pedidos});
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista/lista.ts